export const fixedBody = state => {
  if (state) {
    document.body.classList.add("headerWhite", "headerWhiteSearch")
    document.body.style.overflow = "hidden"
    document.querySelector(".menu").style.pointerEvents = "all"
  } else {
    document.body.style.overflow = ""
    document.body.classList.remove("headerWhite", "headerWhiteSearch")
    document.querySelector(".menu").style.pointerEvents = "none"
  }
}

export const getAdvertBlock = async () => {
  return fetch(`/ajax/getMenuBanners.php`).then(html => html.json())
}
